// VideoEmbed.jsx

import React from 'react';

const VideoEmbed = ({ videoId }) => {
  const googleDriveLink = `https://drive.google.com/file/d/${videoId}/preview?autoplay`;
  // const googleDriveLink = `https://drive.google.com/uc?export=preview&id=${videoId}`;
  return (
    <div className="video-container">
      <iframe
        title="Google Drive Video"
        src={googleDriveLink}
        width="820"
        height="500"
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen
        
      ></iframe>
      {/* <video width="320" height="240" controls>
<source src={googleDriveLink} type="video/mp4"/>
Your browser does not support the video tag.
</video> */}
    </div>
  );
};

export default VideoEmbed;
